import * as Sentry from '@sentry/browser';
import { useCallback } from 'react';
import { type MessageDescriptor, type PrimitiveType, useIntl } from 'react-intl';
import type { TranslationKey } from '../locales-config';
import { useLocales } from './useLocales';

export const doesTranslationKeyExist = (id: TranslationKey, messages: Record<TranslationKey, string>) => id in messages;

export const useFormatMessage = () => {
  const { messages } = useLocales();
  const intl = useIntl();

  return useCallback(
    (descriptor: Omit<MessageDescriptor, 'id'> & { id: TranslationKey }, values?: Record<string, PrimitiveType>) => {
      if (!doesTranslationKeyExist(descriptor.id, messages)) {
        Sentry.captureMessage(`Translation key ${descriptor.id} not found`, 'warning');
      }

      return intl.formatMessage(descriptor, values);
    },
    [intl, messages],
  );
};

export type FormatMessage = ReturnType<typeof useFormatMessage>;
